/* @ngInject */
function vitallyService ($window, $translate, $rootScope, CONSTANTS) {
  var api = {
    initialize
  }

  return api

  function initialize () {
    if (!$window.Vitally) {
      return
    }

    $window.Vitally.init(
      CONSTANTS.VITALLY_API_KEY
    )

    $window.Vitally.nps('survey', {
      userId: $rootScope.oUser.id,
      productName: CONSTANTS.APP_NAME,
      autoLoadSegment: true,
      delay: 1000,
      primaryColor: $rootScope.customerColor,
      npsQuestion: ({ productName }) => $translate.instant('npsQuestion', { productName }),
      followUpTitle: () => {
        function _shouldDisableBtn (isDisabled) {
          const btn = $('.Vitally--Button-button.Vitally--ScorePicker-submitButton')

          if (isDisabled) {
            btn.css({
              'pointer-events': 'none',
              opacity: '0.2'
            })
          } else {
            btn.css({
              'pointer-events': 'all',
              opacity: '1'
            })
          }
        }

        setTimeout(() => {
          const textElem = $('.Vitally--TextArea-input.Vitally--ScorePicker-textArea')

          textElem.on('input propertychange', () => {
            const value = textElem.val()

            _shouldDisableBtn(!value)
          })
        }, 100)

        return $translate.instant('followUpTitle')
      },
      followUpSubtitle: ({ score }) => $translate.instant('followUpSubtitle', { score }),
      thanksTitle: () => $translate.instant('thanksTitle'),
      thanksSubtitle: () => $translate.instant('thanksSubtitle'),
      minLabel: () => $translate.instant('minLabel'),
      maxLabel: () => $translate.instant('maxLabel'),
      placeholderText: () => $translate.instant('placeholderText'),
      submitText: () => $translate.instant('submitText'),
      dismissText: () => $translate.instant('dismissText')
    })
  }
}

export { vitallyService }
